import axiosInstance from ".";

export const getAllUsersList = async () => {
    try {
        const getUsers = await axiosInstance.get("/user/getUserByOrg")
        return getUsers.data
    } catch (error) {
        return error.response?.data || { success: false, message: error.message }
    }
}

export const getAllRoles = async () => {
    try {
        const getRoles = await axiosInstance.get("/role/get")
        return getRoles.data
    } catch (error) {
        return error.response?.data || { success: false, message: error.message }
    }
}


export const updateUserData = async (payload) => {
    try {
        const updateUser = await axiosInstance.put(`/user/update/` + payload.id, payload)
        return updateUser.data
    } catch (error) {
        return error.response?.data || { success: false, message: error.message }
    }
}


export const createUserData = async (payload) => {
    try {
        const createUser = await axiosInstance.post(`/user/create`, payload)
        return createUser.data
    } catch (error) {
        return error.response?.data || { success: false, message: error.message }
    }
}


export const deleteUserData = async (payload) => {
  try {
    // payload.id is coming from record.id
    const res = await axiosInstance.delete(`/user/delete/${payload.id}`);
    return res.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
};


export const getOperatorsByOrg = async () => {
    try {
        const getOperator = await axiosInstance.get(`/user/getUserOperatorByOrg`)
        return getOperator.data
    } catch (error) {
        return error.response?.data || { success: false, message: error.message }
    }
}

export const forgotPassword = async (payload) => {
    try {
        const forgotPassword = await axiosInstance.post(`/user/forgotPassword`, payload)
        return forgotPassword.data
    } catch (error) {
        return error.response?.data || { success: false, message: error.message }
    }
}

export const resetPassword = async (payload) => {
    try {
        const resetPassword = await axiosInstance.post(`/user/resetPassword`, payload)
        return resetPassword.data
    } catch (error) {
        return error.response?.data || { success: false, message: error.message }
    }
}